import { render, staticRenderFns } from "./Overlay.vue?vue&type=template&id=b827c4aa&scoped=true&"
import script from "./Overlay.vue?vue&type=script&lang=js&"
export * from "./Overlay.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./Overlay.vue?vue&type=style&index=0&id=b827c4aa&lang=sass&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "b827c4aa",
  "3073370a"
  
)

export default component.exports